import { useIntl, FormattedMessage } from 'react-intl';
import { Modal, Form, Button, Space } from 'antd';

import { CreateDocumentTypeRequest } from '@/core/domain/enterprise/DocumentTypes/DocumentTypes.types';
import { useCreateDocumentType } from '@/core/domain/enterprise/DocumentTypes/DocumentTypes.hooks';

import { ModalProps } from '@/types/ModalProps';

import AccountsDocumentTypesGeneralForm from '../Form';
import { SaveButton } from '@/components/_common';
import { useHistory } from 'react-router-dom';

function AccountsDocumentTypesGeneralModalForm({
  visible,
  handleVisible,
}: ModalProps) {
  const intl = useIntl();
  const history = useHistory();

  const [form] = Form.useForm<CreateDocumentTypeRequest>();

  const createMutation = useCreateDocumentType();

  const handleOnCancel = () => {
    form.resetFields();
    handleVisible();
  };

  const handleOnSave = async () => {
    try {
      const values = await form.validateFields();

      const response = await createMutation.mutateAsync({
        ...values,
        active: true,
      });

      handleOnCancel();

      history.push(`/app/financial/accounts/documentTypes/${response.id}`);
    } catch (err) {}
  };

  const footer = [
    <Space>
      <Button key={0} onClick={handleVisible}>
        <FormattedMessage id="commons.form.button.close" />
      </Button>

      <SaveButton
        key={1}
        loading={createMutation.isLoading}
        type="primary"
        onClick={handleOnSave}
      >
        <FormattedMessage id="commons.form.button.save" />
      </SaveButton>
    </Space>,
  ];

  return (
    <Modal
      width={680}
      open={visible}
      onCancel={handleOnCancel}
      title={intl.formatMessage({
        id: 'documentTypes.modal.general.new.title',
      })}
      footer={footer}
      destroyOnClose
    >
      <AccountsDocumentTypesGeneralForm form={form} />
    </Modal>
  );
}

export default AccountsDocumentTypesGeneralModalForm;
